import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import type { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import type { HistoryFindInterface } from '@zaoblako/shared/common/dtos/history/history-find.dto';
import { BannerService } from '@zaoblako/web/core/services/client/banner.service';
import { ButtonShowAndHideComponent } from '@zaoblako/web/shared/components/button-show-and-hide/button-show-and-hide.component';
import { FormStoreService } from '@zaoblako/web/shared/components/form-sidebar/services/form-store.service';
import { UserAvatarComponent } from '@zaoblako/web/shared/components/user-avatar/user-avatar.component';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { OrderByPipe } from '@zaoblako/web/shared/pipes/order-by.pipe';
import { CardModule } from 'primeng/card';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TimelineModule } from 'primeng/timeline';

@Component({
  selector: 'crm-banner-history',
  standalone: true,
  imports: [
    CommonModule,
    CardModule,
    ButtonShowAndHideComponent,
    TimelineModule,
    UserAvatarComponent,
    SpinnerComponent,
    ProgressSpinnerModule,
    OrderByPipe
  ],
  templateUrl: './banner-history.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BannerHistoryComponent {
  @Input() public readonly index: number;

  public bannerHistory: {
    items: HistoryFindInterface[];
    queryParams: PaginationQueryInterface;
    paginationLoading: boolean;
    loading: boolean;
    count: number;
    showHistory: boolean;
  } = {
    items: [],
    queryParams: {
      limit: 100,
      offset: 0
    },
    paginationLoading: false,
    loading: true,
    count: 0,
    showHistory: false
  };

  public constructor(
    private readonly bannerService: BannerService,
    private readonly formStoreService: FormStoreService,
    private readonly cdRef: ChangeDetectorRef
  ) {}

  public toHistory(item: any): HistoryFindInterface {
    return item as HistoryFindInterface;
  }

  public isShowChange(isShow: boolean) {
    if (isShow) {
      this.loadHistory({
        ...this.bannerHistory.queryParams,
        offset: 0
      });
    }
    this.bannerHistory = {
      ...this.bannerHistory,
      showHistory: !this.bannerHistory.showHistory
    };
  }

  public loadHistory(queryParams: PaginationQueryInterface) {
    this.bannerHistory = {
      ...this.bannerHistory,
      queryParams,
      loading: true
    };

    this.bannerService
      .getHistoryById(this.formStoreService.getState.forms[this.index]?.entityId, this.bannerHistory.queryParams)
      .subscribe({
        next: (history) => {
          this.bannerHistory = {
            ...this.bannerHistory,
            items: history.items,
            count: history.count,
            loading: false
          };
          this.cdRef.markForCheck();
        }
      });
  }

  public onScrollEndHistory(target: HTMLElement): void {
    if (target.offsetHeight + target.scrollTop >= target.scrollHeight) {
      if (
        this.bannerHistory?.items?.length < this.bannerHistory?.count &&
        !this.bannerHistory?.paginationLoading &&
        !this.bannerHistory?.loading
      ) {
        this.bannerHistory = {
          ...this.bannerHistory,
          queryParams: {
            ...this.bannerHistory.queryParams,
            offset: this.bannerHistory.queryParams.offset + this.bannerHistory.queryParams.limit
          },
          paginationLoading: true
        };

        this.bannerService
          .getHistoryById(this.formStoreService.getState.forms[this.index]?.entityId, this.bannerHistory.queryParams)
          .subscribe({
            next: (history) => {
              this.bannerHistory = {
                ...this.bannerHistory,
                items: this.bannerHistory.items.concat(history.items),
                count: history.count,
                paginationLoading: false
              };
              this.cdRef.markForCheck();
            }
          });
      }
    }
  }
}
